import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

const { FiPlayCircle } = FiIcons;

const Demo = () => {
  return (
    <div className="py-20 bg-slate-900 text-white min-h-[80vh] flex flex-col items-center justify-center">
      <div className="container px-4 mx-auto max-w-5xl text-center">
        <h1 className="mb-6 text-4xl font-bold md:text-5xl">See Review Builder Pro in Action</h1>
        <p className="mb-12 text-xl text-slate-400 max-w-2xl mx-auto">Watch our quick 3-minute demo to see how easy it is to automate your review generation and manage your online reputation.</p>
        
        <div className="relative w-full overflow-hidden max-w-4xl mx-auto rounded-2xl aspect-video bg-slate-800 shadow-2xl border border-slate-700 group cursor-pointer flex items-center justify-center">
          {/* Placeholder for embedded video */}
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center opacity-40 mix-blend-overlay transition-opacity group-hover:opacity-30"></div>
          <SafeIcon icon={FiPlayCircle} className="w-20 h-20 text-white z-10 opacity-80 group-hover:opacity-100 transition-opacity group-hover:scale-110 duration-300" />
        </div>

        <div className="mt-16 bg-slate-800 p-10 rounded-2xl max-w-3xl mx-auto border border-slate-700">
          <h2 className="text-2xl font-bold mb-4">Ready to try it yourself?</h2>
          <p className="text-slate-400 mb-8">Get hands-on experience with our 14-day free trial. No credit card required.</p>
          <Button to="/free-trial" variant="accent" size="lg" className="text-primary">Start Free Trial</Button>
        </div>
      </div>
    </div>
  );
};

export default Demo;